import { I18n } from '@calendly/i18n';
import { ContextualBanner } from '@calendly/ui/components/contextual-banner';
import { Tabs, Tab } from '@calendly/ui/components/tabs';
import classNames from 'classnames';
import { useState, forwardRef } from 'react';
import LoadingState from 'components/core/loading_state';
import { useFetchPollQuery } from '../api';
import { Details } from './details';
import { Header } from './header';
import { SectionContainer } from './section_container';
import { Summary } from './summary';
import { TopTimes, AllTimes } from './times';
const tabsContainerCss = "t1nex0v8";
const TabsContainer = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(tabsContainerCss, props.className)} />;
});
const Body = ({
  poll,
  activeTab
}) => {
  const {
    status
  } = poll;
  if (activeTab === 'votes') {
    return <>
        <SectionContainer>
          {status === 'expired' ? <ContextualBanner variant="danger">
              {I18n.t('publisher.scheduling.polls.expired_notice')}
            </ContextualBanner> : <>
              <Summary poll={poll} />
              <TopTimes poll={poll} />
            </>}
        </SectionContainer>
        <AllTimes poll={poll} />
      </>;
  }
  return <Details poll={poll} />;
};
export const Poll = ({
  id
}) => {
  const {
    data: poll,
    isFetching,
    isError
  } = useFetchPollQuery(id);
  const [activeTab, setActiveTab] = useState('votes');
  if (isFetching) return <LoadingState />;
  if (isError) return null;
  return <div>
      <Header poll={poll} />
      <TabsContainer>
        <Tabs underlined>
          <Tab selected={activeTab === 'votes'} onClick={() => setActiveTab('votes')}>
            {I18n.t('publisher.scheduling.polls.tabs.votes')}
          </Tab>
          <Tab selected={activeTab === 'details'} onClick={() => setActiveTab('details')}>
            {I18n.t('publisher.dashboard.event.details')}
          </Tab>
        </Tabs>
      </TabsContainer>
      <Body activeTab={activeTab} poll={poll} />
    </div>;
};

require("./poll.wyw-in-js.css!=!../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./poll.js");